export default class InvalidSignInMethod extends Error {
  provider: string | null | undefined;

  constructor(provider?: string | null) {
    super(`Invalid sign in method`);

    this.provider = provider;
  }
}
